import { render, staticRenderFns } from "./IdentityGrid.vue?vue&type=template&id=0a78add9&"
import script from "./IdentityGrid.vue?vue&type=script&lang=js&"
export * from "./IdentityGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports